<template>
  <v-dialog scrollable :value="dialog" @input="closeModal" >
    <v-card>
      <v-card-actions>
        <v-card-title>
          <span class="wrapword">{{ displayName }}</span>
        </v-card-title>
      </v-card-actions>
      <v-card-text class="text-center">
        <object v-if="type == 'application/pdf'" v-auth-image="fileName" :type="type" style="width: 100%; height: 70vh"/>
        <audio v-else-if="type.search('audio') != -1" v-auth-image="fileName" :type="type" controls/>
        <img v-else-if="type.search('image') != -1" v-auth-image="fileName" style="max-width: 100%; height: auto;"/>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn text tag="a" v-auth-image="fileName" :download="displayName" target="_blank" color="primary">
          <v-icon left>mdi-arrow-down</v-icon> Baixar Arquivo
        </v-btn>
        <v-btn text @click="closeModal()" color="red">
          <v-icon left>mdi-close</v-icon> Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false
    },
    fileId: {
      required: true,
      default: () => -1,
      type: String
    },
    fileName: {
      required: true,
      default: () => '',
      type: String
    },
    displayName: {
      required: false,
      default: () => 'Material de Apoio',
      type: String
    },
    type: {
      required: true,
      default: () => 'application/pdf',
      type: String
    }
  },
  computed: {

  },
  methods: {
    fileType (path) {
      const aux = path.split('.')
      return aux[aux.length - 1]
    },
    closeModal () {
      this.$emit('update:dialog', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapword {
  white-space: -moz-pre-wrap !important;  /* Mozilla, since 1999 */
  white-space: -webkit-pre-wrap;          /* Chrome & Safari */
  white-space: -pre-wrap;                 /* Opera 4-6 */
  white-space: -o-pre-wrap;               /* Opera 7 */
  white-space: pre-wrap;                  /* CSS3 */
  word-wrap: break-word;                  /* Internet Explorer 5.5+ */
  word-break: break-all;
  white-space: normal;
}

.image-download {
  text-decoration: none !important;
  color: white;
  padding: 0 16px;
}
</style>
